import NiceModal from '@ebay/nice-modal-react';

import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, FINANCE } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

import AddBankModal from './AddBankModal';

const BankList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'id', filterType: FilterType.number, width: 70 },
			{
				Header: 'bankName',
				accessor: 'bankName',
				filterType: FilterType.string
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				width: 100
			},
			{
				Header: 'BIC',
				accessor: 'BIC',
				filterType: FilterType.string
			},
			{
				Header: 'bankCode',
				accessor: 'bankCode',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/payments-icon.json.gz"
				title="banks">
				<Authorization path="/modal/add-bank-modal">
					<Button
						lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/addOrder-icon.json.gz"
						label="addBank"
						variant="blue"
						className="addButton"
						onClick={() => NiceModal.show(AddBankModal)}></Button>
				</Authorization>
			</PageHeader>

			<DynamicList
				id={DYNAMICLISTS.BANKS}
				columns={columns}
				fetchUrl={FINANCE.GET_BANK_LIST}
				exportName="banks"
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				defaultSort={defaultSort}
			/>
		</div>
	);
};

export default BankList;
